import { FormControl } from "@angular/forms";

export interface ModuleData {
    qdfota: string;
    qdtool: string;
    module: string;
};

export interface ModuleDataForm {
    qdfota: FormControl<string | null>;
    qdtool: FormControl<string | null>;
    module: FormControl<string | null>;
};